import React, { useEffect, useState } from 'react';
import '../../Styles/main.css';
import { getAllIncome, getCity, getCountry, getEducation, getOccupation, getState, addProfessionalDetails } from '../../asiosConfig';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { professionalDetailSchema } from '../ValidationSchema';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function CareerDetailForm() {
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [occupationList, setOccupationList] = useState([]);
  const [income, setIncome] = useState([]);
  const navigate = useNavigate();
  const indiaId = 233;
  // const tokan = localStorage.getItem('token');
  const initialValues = {
    education: '',
    educationDetail: '',
    occupation: '',
    occupationDetail: '',
    income: '',
    country: indiaId,
    state: '',
    city: '',
    user_id: localStorage.getItem('user'),
    // tokan: tokan
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [countryRes, educationRes, occupationRes, incomeRes] = await Promise.all([
          getCountry(),
          getEducation(),
          getOccupation(),
          getAllIncome(),
        ]);
        setCountryList(countryRes.data.data);
        setEducationList(educationRes.data.data);
        setOccupationList(occupationRes.data.data);
        setIncome(incomeRes.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (initialValues.country) {
      fetchState(initialValues.country);
    }
  }, [initialValues.country]);

  useEffect(() => {
    if (initialValues.state) {
      fetchCity(initialValues.state);
    }
  }, [initialValues.state]);

  const fetchState = async (country_id) => {
    try {
      const response = await getState(country_id);
      setStateList(response.data.data);
    } catch (error) {
      console.error('Error fetching State:', error);
    }
  };

  const fetchCity = async (state_id) => {
    try {
      const response = await getCity(state_id);
      setCityList(response.data.data);
    } catch (error) {
      console.error('Error fetching City:', error);
    }
  };

  const handleCountryChange = (event, setFieldValue) => {
    const country_id = event.target.value;
    setFieldValue('country', country_id);
    setFieldValue('state', '');
    setFieldValue('city', '');
    fetchState(country_id);
  };

  const handleStateChange = (event, setFieldValue) => {
    const state_id = event.target.value;
    setFieldValue('state', state_id);
    setFieldValue('city', '');
    fetchCity(state_id);
  };

  const handleSubmit = async (values, { setSubmitting }) => {

    try {
      const response = await addProfessionalDetails(values);
      if (response.status === 200 || response.status === 201) {
        localStorage.setItem('users', response.data);
        localStorage.setItem('last_complete_step', response.data.last_complete_step);
        toast.success(response.data.message);
        setTimeout(() => {
          navigate('/contactReligion');
      }, 2000);  // 2000ms = 2 seconds
        // window.location.reload();
      } else {
        toast.error(response.data.message || 'Invalid username or password');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className='siteForm flex-grow-1'>
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-md-5">
            <div className="formTitle">
              <h3>Education and Career Details</h3>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={professionalDetailSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, setFieldValue }) => (
                <Form className='mt-4'>
                  <div className="mb-3">
                    <label className='form-label'>Education</label>
                    <Field
                      as="select"
                      name="education"
                      className="form-select"
                    >
                      <option value="">Select Education</option>
                      {educationList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.education}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="education" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Education Details</label>
                    <Field
                      as="textarea"
                      name="educationDetail"
                      className="form-control"
                      rows="3"
                    />
                    <ErrorMessage name="educationDetail" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Profession</label>
                    <Field
                      as="select"
                      name="occupation"
                      className="form-select"
                    >
                      <option value="">Select Profession</option>
                      {occupationList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.occupation}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="occupation" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Profession Details</label>
                    <Field
                      as="textarea"
                      name="occupationDetail"
                      className="form-control"
                      rows="3"
                    />
                    <ErrorMessage name="occupationDetail" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Annual Income</label>
                    <Field
                      as="select"
                      name="income"
                      className="form-select"
                    >
                      <option value="">Select Income</option>
                      {income.map((item) => (
                        <option key={item.tbl_income_id} value={item.tbl_income_id}>
                          {item.income_type}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="income" component="div" className='text-danger' />
                  </div>
                  <div className="mb-3">
                    <label className='form-label'>Residing Country</label>
                    <Field
                      as="select"
                      name="country"
                      className="form-select"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                    >
                      <option value="">Select Country</option>
                      {countryList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.country}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="country" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Residing State</label>
                    <Field
                      as="select"
                      name="state"
                      className="form-select"
                      onChange={(e) => handleStateChange(e, setFieldValue)}
                    >
                      <option value="">Select State</option>
                      {stateList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.state}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="state" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <label className='form-label'>Residing City</label>
                    <Field
                      as="select"
                      name="city"
                      className="form-select"
                    >
                      <option value="">Select City</option>
                      {cityList.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.city}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="city" component="div" className='text-danger' />
                  </div>

                  <div className="mb-3">
                    <button
                      type="submit"
                      className="btn btn-primary formBtn"
                      disabled={isSubmitting}
                    >
                      Save & Continue
                    </button>
                  </div>
                  <br />
                  <br />
                </Form>
              )}
            </Formik>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareerDetailForm;
